import VCheckbox from './VCheckbox'
import VSimpleCheckbox from './VSimpleCheckbox'

export { VCheckbox, VSimpleCheckbox }
export default {
  $_ifrontui_subcomponents: {
    VCheckbox,
    VSimpleCheckbox,
  },
}
